import { WalletAddressFormInput } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';

const FormWalletAddressInputs = () => {
	const { formDataContextProps, tokenOptions, walletInfoData, authSettings } = useWithdrawUsdRequestContext();

	return (
		<WalletAddressFormInput
			formDataContextProps={formDataContextProps}
			tokenOptions={tokenOptions}
			walletInfoData={walletInfoData}
			authSettings={authSettings}
		/>
	);
};

export default FormWalletAddressInputs;
